import React, { useState } from "react";
import { PlusIcon, StyledBreadcrumb } from "@aureskonnect/react-ui";
import { ToastContainer } from "react-toastify";
import { DynamicTable } from "@maherunlocker/custom-react-table";
import { useTranslation } from "react-i18next/";
import { useSnapshot } from "valtio";
import { useLocation } from "react-router-dom";
import { getPathAuthorization } from "@components/VerticalLayout";
import classnames from "classnames";

import { setAllCashManagements } from "@pages/Applications/DeviceAssociateModal/store";
import { store } from "../../../components/VerticalLayout/store";
import {
    setIsMultiDeletePeripheralModalOpened,
    setLocalShopIdList,
    setSelectedMonnyeur,
    store as cashManagementStore,
    setIsEdited,
    setIsActionsClicked,
    setActions,
    setValidationAction,
    setModify,
    setIsLoading,
    setKey,
} from "./store";

import PageTitle from "@components/Common/PageTitle";
import MessageInfo from "@components/Common/MessageInfo";
import { ConfirmationDeleteMessage } from "@components/Common/ConfirmationDeleteMessage";
import { ConfirmationInitializationMessage } from "@components/Common/ConfirmationInitializationMessage";
import { arrayGroupedString } from "@helpers/general";
import { AlertDeletePeripheralMessage } from "@components/Common/AlertDeletePeripheralMessage";
import { ConfirmationMessageEditPeripheral } from "@components/Common/ConfirmationMessageEditPeripheral";
import { ConfirmationMultiDeleteMessage } from "@components/Common/ConfirmationMultiDeleteMessage";
import { useCallbackPrompt } from "@hooks/useCallbackPrompt";
import { ConfirmationUpdatingDataMessageModal } from "@components/Common/ConfirmationUpdatingDataMessageModal";

import { CashManagementConfigure } from "./CashManagementConfigure";
import ModalConfigurations from "./ModalConfigurations";
import { CustomIcons } from "./CustomIcons";
import DropdownAction from "./DropdownAction";
import HistoryModal from "./HistoryModal";
import BadgeNumber from "@components/Common/BadgeNumber";

import { CustomMainColorIconButton } from "@components/Common/CustomMainColorIconButton";
import { CustomMainColorButtonWithIcon } from "@components/Common/CustomMainColorButtonWithIcon";

import "./ModalConfigurations/index.css";
import { useSelector } from "react-redux";
import { useAuthHeader } from "../../../api/headersKeycloak";

type CustomColumnProps = {
    indexOFColumn: number;
    columnName: string;
    customJsx: React.ReactNode;
};

export default function CashManagement() {
    const location = useLocation();
    const didMountRef = React.useRef(false);

    const getAuthHeader = useAuthHeader();
    const {
        isMultiDeletePeripheralModalOpened,
        isEdited,
        actions,
        validationAction,
        isActionsClicked,
        modify,
        key,
    } = useSnapshot(cashManagementStore);
    const { oneShop, userID, franchiseID, shopID, operatorID } = useSnapshot(
        store
    );
    const authorizationList = useSelector(
        (state: any) => state.global.infoUser.profileAuthorization
    );
    const selectedAccount = useSelector(
        (state: any) => state.global.selectedAccount
    );
    setModify(
        getPathAuthorization(location.pathname, authorizationList).Modifie
    );
    const { t } = useTranslation();

    const [showPrompt, confirmNavigation, cancelNavigation] = useCallbackPrompt(
        isEdited
    );

    const [isHistoryModalOpened, setIsHistoryModalOpened] = React.useState<
        boolean
    >(false);
    const [
        isConfiguredCashManagementClicked,
        setIsConfiguredCashManagementClicked,
    ] = React.useState<boolean>(false);

    const [
        isAddCashManagementClicked,
        setIsAddCashManagementClicked,
    ] = React.useState<boolean>(false);
    const [
        isAddNewCashManagementButtonClicked,
        setIsAddNewCashManagementButtonClicked,
    ] = React.useState<boolean>(false);
    const [
        isConfirmationEditRunning,
        setIsConfirmationEditRunning,
    ] = React.useState<boolean>(false);
    const [filterActive, setLocalFilterActive] = React.useState<boolean>(false);
    const [dataIsUpdated, setDataIsUpdated] = React.useState<boolean | number>(
        false
    );
    const [selectedIds, setSelectedIds] = React.useState<any>([]);
    const [ListNumberOrigin, setListNumberOrigin] = React.useState<any>({
        nbrNotArchived: 0,
        nbrArchived: 0,
    });
    const [typeDisplay, setTypeDisplay] = React.useState<string>("notArchived");
    const [editedData, setEditedData] = React.useState<any>([]);
    const [data, setData] = React.useState<any>([]);
    const [configuredData, setConfiguredData] = React.useState<any>([]);

    const [isModalOpened, setIsModalOpened] = React.useState<boolean>(false);
    const [
        isInInitializationModalOpened,
        setIsInInitializationModalOpened,
    ] = React.useState<boolean>(false);

    const [cashManagementId, setCashManagementId] = React.useState<string>("");
    const [shopId, setShopId] = React.useState<string | number>(
        oneShop ? shopID : 0
    );
    const [selectedRows, setSelectedRows] = React.useState<any[]>([]);
    const [localShop, setLocalShop] = React.useState<any[]>([]);
    const [inputDesignation, setInputDesignation] = useState<boolean>(false);
    const [inputMarque, setInputMarque] = useState<boolean>(false);
    const [inputIp, setInputIp] = React.useState<boolean>(false);

    const [isConsult, setIsConsult] = React.useState<boolean>(false);
    const i18nextLng = localStorage.getItem("i18nextLng") || "fr";
    const uuidUser = localStorage.getItem("uuidUser");
    const [url, setUrl] = React.useState<string>(
        oneShop
            ? `${process.env.REACT_APP_API_V2_URL}/settings/cash_management?userId=${userID}&shopId=${shopID}&franchiseId=${franchiseID}&typeDisplay=${typeDisplay}&uuidUser=${uuidUser}`
            : `${process.env.REACT_APP_API_V2_URL}/settings/cash_management?userId=${userID}&franchiseId=${franchiseID}&typeDisplay=${typeDisplay}&uuidUser=${uuidUser}`
    );
    const [isShopSelected, setIsShopSelected] = React.useState<boolean>(false);

    const [
        isModalDeleteAssociatePeripheralOpened,
        setIsModalDeleteAssociatePeripheralOpened,
    ] = React.useState<boolean>(false);
    const [objectApiUrlDissociate, setObjectApiUrlDissociate] = React.useState<
        any
    >({});
    React.useEffect(() => {
        if (editedData.Id) {
            if (
                data.data.filter((bt: any) => {
                    return bt.shopId === editedData.shopId;
                })[0]?.subRows !== undefined &&
                data.data
                    .filter((bt: any) => {
                        return bt.shopId === editedData.shopId;
                    })[0]
                    ?.subRows.filter((imp: any) => {
                        return imp.Id === editedData.Id;
                    })[0] !== undefined
            ) {
                setEditedData(
                    data.data
                        .filter((bt: any) => {
                            return bt.shopId === editedData.shopId;
                        })[0]
                        ?.subRows.filter((imp: any) => {
                            return imp.Id === editedData.Id;
                        })[0]
                );
            }
        }

        // eslint-disable-next-line
    }, [data]);
    React.useEffect(() => {
        let localShop: string[] = [];
        var localShopId: string[] = [];
        let ids: any[] = [];
        let array: any = [];
        selectedRows.forEach((el: any) => {
            if (el[t("Shop")] !== "" && el[t("Shop")] !== undefined) {
                localShop.push(el.shopId);
                localShopId.push(el.shopId);
            } else {
                ids.push({
                    Id: el.Id,
                    isArchived:
                        typeDisplay === "notArchived" ? "true" : "false",
                    shopId: el.shopId,
                    userID: userID,
                    franchiseID: franchiseID,
                });
            }
        });

        selectedRows.forEach((element: any) => {
            if (element.Id !== undefined) {
                array.push({ [element.shopId]: element.Id });
            }
        });

        setSelectedMonnyeur(array);
        setIsShopSelected(localShop.length === 1);
        if (oneShop === false) {
            setLocalShopIdList(arrayGroupedString(localShopId));
        } else {
            setLocalShopIdList([]);
        }
        setSelectedIds(ids);
        setLocalShop(localShop);
        setIsShopSelected(localShop.length >= 1);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedRows, oneShop]);

    React.useEffect(() => {
        if (filterActive) {
            setIsAddCashManagementClicked(false);
            setEditedData([]);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filterActive]);

    React.useEffect(() => {
        if (isAddCashManagementClicked === true) {
            setLocalFilterActive(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isAddCashManagementClicked]);

    const disableCheckbox = () => {
        let checks = document.getElementsByClassName("PrivateSwitchBase-input");

        for (let i = 0; i < checks.length; i++) {
            checks[i].classList.add("not-allowed-icon-check__clz");
        }
    };

    let arrayOfCustomColumns: CustomColumnProps[] = [
        {
            indexOFColumn: oneShop ? 5 : 7,
            columnName: t("Actions"),
            customJsx: (e: any) => (
                <CustomIcons
                    isAddCashManagementClicked={isAddCashManagementClicked}
                    setIsAddCashManagementClicked={
                        setIsAddCashManagementClicked
                    }
                    e={e}
                    setShopId={setShopId}
                    setEditedData={setEditedData}
                    setConfiguredData={setConfiguredData}
                    setIsModalOpened={setIsModalOpened}
                    isModalOpened={isModalOpened}
                    isConfiguredCashManagementClicked={
                        isConfiguredCashManagementClicked
                    }
                    setIsConfiguredCashManagementClicked={
                        setIsConfiguredCashManagementClicked
                    }
                    setCashManagementId={setCashManagementId}
                    isModalDeleteAssociatePeripheralOpened={
                        isModalDeleteAssociatePeripheralOpened
                    }
                    setIsModalDeleteAssociatePeripheralOpened={
                        setIsModalDeleteAssociatePeripheralOpened
                    }
                    objectApiUrlDissociate={objectApiUrlDissociate}
                    setObjectApiUrlDissociate={setObjectApiUrlDissociate}
                    setInputIp={setInputIp}
                    setLocalShop={setLocalShop}
                    setIsConfirmationEditRunning={setIsConfirmationEditRunning}
                    typeDisplay={typeDisplay}
                    setIsConsult={setIsConsult}
                    setSelectedRows={setSelectedRows}
                    setIsHistoryModalOpened={setIsHistoryModalOpened}
                    isConsult={isConsult}
                />
            ),
        },
        {
            indexOFColumn: oneShop ? 0 : 2,
            columnName: t("Designation"),
            customJsx: (e: any) => {
                return (
                    <div>
                        {!oneShop ? (
                            e.selectedRow["Boutique"] !== undefined ||
                            (e.selectedRow["Boutique"] !== "" &&
                                e.selectedRow.subRows) !== undefined ? (
                                <BadgeNumber
                                    value={e.selectedRow.subRows?.length}
                                />
                            ) : (
                                e.selectedRow[t("Designation")]
                            )
                        ) : (
                            e.selectedRow[t("Designation")]
                        )}
                    </div>
                );
            },
        },
    ];

    React.useEffect(() => {
        setListNumberOrigin(data?.othersData?.ListNumberOrigin);
        // eslint-disable-next-line
    }, [data]);

    React.useEffect(() => {
        setUrl(
            oneShop
                ? `${process.env.REACT_APP_API_V2_URL}/settings/cash_management?userId=${userID}&shopId=${shopID}&franchiseId=${franchiseID}&typeDisplay=${typeDisplay}&uuidUser=${uuidUser}`
                : `${process.env.REACT_APP_API_V2_URL}/settings/cash_management?userId=${userID}&franchiseId=${franchiseID}&typeDisplay=${typeDisplay}&uuidUser=${uuidUser}`
        );
        setIsAddCashManagementClicked(false);
        setEditedData([]);
        if (didMountRef.current) {
            setDataIsUpdated(true);
        } else {
            didMountRef.current = true;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [typeDisplay, i18nextLng]);

    React.useEffect(() => {
        if (selectedRows[0] !== undefined) {
            selectedRows[0].subRows.forEach((e: any) => {
                setAllCashManagements(e);
            });
        }
        setUrl(
            oneShop
                ? `${process.env.REACT_APP_API_V2_URL}/settings/cash_management?userId=${userID}&shopId=${shopID}&franchiseId=${franchiseID}&typeDisplay=${typeDisplay}&uuidUser=${uuidUser}`
                : `${process.env.REACT_APP_API_V2_URL}/settings/cash_management?userId=${userID}&franchiseId=${franchiseID}&typeDisplay=${typeDisplay}&uuidUser=${uuidUser}`
        );
        setIsAddCashManagementClicked(false);
        setEditedData([]);
        if (didMountRef.current) {
            setDataIsUpdated(true);
        } else {
            didMountRef.current = true;
        }

        // eslint-disable-next-line
    }, [oneShop, userID, franchiseID, shopID]);

    React.useEffect(() => {
        setActions(confirmNavigation);
        setIsActionsClicked(showPrompt as boolean);
        setValidationAction(cancelNavigation);
    }, [showPrompt, confirmNavigation, cancelNavigation]);

    return (
        <React.Fragment>
            <PageTitle title={t("Peripherals")} />
            <div className="page-content__clz">
                <div className="mon_txt_coinOperatedDevice">
                    {" "}
                    <StyledBreadcrumb
                        items={[
                            {
                                item: "Settings".toUpperCase(),
                                link: `${process.env.REACT_APP_PORTAIL_URL}`,
                            },
                            {
                                item: selectedAccount?.toUpperCase() || "",
                                link: oneShop
                                    ? "/setting/customer-account"
                                    : "/compte",
                            },
                            {
                                item: t("Peripherals").toUpperCase(),
                                link: "#",
                            },
                            {
                                item: t(
                                    typeDisplay === "notArchived"
                                        ? "Coiners"
                                        : "Archived coiner"
                                ).toUpperCase(),
                                link: "#",
                            },
                        ]}
                    />
                </div>

                <MessageInfo
                    message={t(
                        "In this section, you can add and configure the cash management."
                    )}
                />

                <div
                    style={{
                        display: "grid",
                        minHeight: "650px",
                        gridTemplateColumns: isAddCashManagementClicked
                            ? "2fr 1fr "
                            : "auto",
                        gridColumnGap: "4px",
                        border: 0,
                    }}
                >
                    <DynamicTable
                        key={key}
                        url={url}
                        requestHeader={{
                            "Accept-Language": i18nextLng,
                            ...getAuthHeader,
                        }}
                        customJsxSideFilterButton={
                            <div className="d-flex justify-content-start align-items-center ml-2">
                                {modify === true &&
                                isAddCashManagementClicked !== true ? (
                                    <div>
                                        <span
                                            onClick={() => {
                                                disableCheckbox();
                                                setShopId(
                                                    oneShop === false
                                                        ? selectedRows[0].shopId
                                                        : shopID
                                                );
                                                setIsAddCashManagementClicked(
                                                    !isAddCashManagementClicked
                                                );
                                                setLocalFilterActive(false);
                                            }}
                                            className={`cmn_btn_openForm ${classnames(
                                                {
                                                    "not-allowed-icon__clz":
                                                        (!isShopSelected &&
                                                            !oneShop) ||
                                                        typeDisplay ===
                                                            "archived",
                                                }
                                            )}`}
                                        >
                                            <CustomMainColorButtonWithIcon
                                                icon="PlusIcon"
                                                iconPosition="left"
                                                className="w-100"
                                                style={{ height: "0px" }}
                                                rounded
                                                variant="primary"
                                            >
                                                {t("Add device")}
                                            </CustomMainColorButtonWithIcon>
                                        </span>
                                    </div>
                                ) : modify === true ? (
                                    <div className="d-flex justify-content-start">
                                        <CustomMainColorIconButton
                                            icon="PlusIcon"
                                            className="bg-dark mon_btn_reset"
                                            rounded
                                            disabled={
                                                editedData.length === 0
                                                    ? false
                                                    : true
                                            }
                                            onClick={() => {
                                                if (isEdited === true)
                                                    setIsInInitializationModalOpened(
                                                        true
                                                    );
                                                else {
                                                    setInputDesignation(false);
                                                    setInputMarque(false);
                                                }
                                            }}
                                        >
                                            <PlusIcon
                                                height={20}
                                                width={20}
                                                fill="white"
                                            />
                                        </CustomMainColorIconButton>
                                    </div>
                                ) : null}
                                <DropdownAction
                                    setIsAddCashManagementClicked={
                                        setIsAddCashManagementClicked
                                    }
                                    typeDisplay={typeDisplay}
                                    setTypeDisplay={setTypeDisplay}
                                    selectedIds={selectedIds}
                                    ListNumberOrigin={ListNumberOrigin}
                                    setDataIsUpdated={setDataIsUpdated}
                                    setIsHistoryModalOpened={
                                        setIsHistoryModalOpened
                                    }
                                />
                            </div>
                        }
                        canMovedCheckboxLeftOnExpand
                        setDataIsUpdated={setDataIsUpdated}
                        dataIsUpdated={dataIsUpdated}
                        canResize
                        customSelect
                        setData={setData}
                        actionColumn={() => <></>}
                        showGlobalFilter
                        arrayOfCustomColumns={arrayOfCustomColumns}
                        filterActive={filterActive}
                        setLocalFilterActive={setLocalFilterActive}
                        elevationTable={1}
                        minHeight="500px"
                        maxHeight="500px"
                        canExpand={oneShop ? false : true}
                        canSelect
                        setSelectedRows={setSelectedRows}
                        showFilter
                    />

                    {isAddCashManagementClicked ? (
                        <CashManagementConfigure
                            setIsAddCashManagementClicked={
                                setIsAddCashManagementClicked!
                            }
                            isAddCashManagementClicked={
                                isAddCashManagementClicked
                            }
                            setDataIsUpdated={setDataIsUpdated}
                            isAddNewCashManagementButtonClicked={
                                isAddNewCashManagementButtonClicked
                            }
                            editedData={editedData}
                            setEditedData={setEditedData}
                            shopId={shopId}
                            isEdited={isEdited}
                            setIsEdited={setIsEdited}
                            setInputDesignation={setInputDesignation}
                            inputDesignation={inputDesignation}
                            setInputMarque={setInputMarque}
                            inputMarque={inputMarque}
                            setInputIp={setInputIp}
                            inputIp={inputIp}
                            dataTable={data}
                            localShopId={oneShop ? [shopID] : localShop}
                            isConsult={isConsult}
                            setIsConsult={setIsConsult}
                        />
                    ) : null}
                </div>
                <ToastContainer limit={2} />
                <ModalConfigurations
                    setIsConfiguredCashManagementClicked={
                        setIsConfiguredCashManagementClicked
                    }
                    isConfiguredCashManagementClicked={
                        isConfiguredCashManagementClicked
                    }
                    data={configuredData}
                    dataM={{
                        userId: userID,
                        shopId: shopId,
                        franchiseId: franchiseID,
                    }}
                    setDataIsUpdated={setDataIsUpdated}
                />
                {isModalDeleteAssociatePeripheralOpened === false ? (
                    <ConfirmationDeleteMessage
                        isModalOpened={isModalOpened}
                        setIsModalOpened={setIsModalOpened}
                        setDataIsUpdated={setDataIsUpdated}
                        text={t(
                            typeDisplay === "notArchived"
                                ? "Please confirm archivation of this device"
                                : "Please confirm unarchivation of this device"
                        )}
                        message={t(
                            typeDisplay === "notArchived"
                                ? "The device was successfully archived"
                                : "The device was successfully unarchived"
                        )}
                        apiUrl={`${
                            process.env.REACT_APP_API_V2_URL
                        }/settings/cashManagement?userId=${userID}&shopId=${shopId}&franchiseId=${franchiseID}&operatorId=${operatorID}&id=${cashManagementId}&isArchived=${
                            typeDisplay === "notArchived" ? "true" : "false"
                        }&uuidUser=${uuidUser}`}
                        data={{ shopId: shopId }}
                        setKey={setKey}
                        setIsLoading={setIsLoading}
                    />
                ) : (
                    <AlertDeletePeripheralMessage
                        text={t(
                            "This device is associated with one or more applications! Unable to perform delete action"
                        )}
                        isModalDeleteAssociatePeripheralOpened={
                            isModalDeleteAssociatePeripheralOpened
                        }
                        setIsModalDeleteAssociatePeripheralOpened={
                            setIsModalDeleteAssociatePeripheralOpened
                        }
                    />
                )}
                {isInInitializationModalOpened === true ? (
                    <ConfirmationInitializationMessage
                        isModalOpened={isInInitializationModalOpened}
                        setIsModalOpened={setIsInInitializationModalOpened}
                        setIsClicked={setIsAddNewCashManagementButtonClicked}
                        isClicked={isAddNewCashManagementButtonClicked}
                        setIsEdited={setIsEdited}
                    />
                ) : null}
                {isConfirmationEditRunning === true ? (
                    <ConfirmationMessageEditPeripheral
                        isModalOpened={isConfirmationEditRunning}
                        setIsModalOpened={setIsConfirmationEditRunning}
                        setCancel={setIsAddCashManagementClicked}
                        archive={typeDisplay === "archived"}
                    />
                ) : null}
                {isMultiDeletePeripheralModalOpened === true && (
                    <ConfirmationMultiDeleteMessage
                        isModalOpened={isMultiDeletePeripheralModalOpened}
                        setIsModalOpened={setIsMultiDeletePeripheralModalOpened}
                    />
                )}
                {isHistoryModalOpened ? (
                    <HistoryModal
                        isModalOpened={isHistoryModalOpened}
                        setIsModalOpened={setIsHistoryModalOpened}
                        setGlobalDataUpdated={setDataIsUpdated}
                    />
                ) : null}
                {isActionsClicked === true ? (
                    <ConfirmationUpdatingDataMessageModal
                        isModalOpened={isActionsClicked}
                        setIsModalOpened={setIsActionsClicked}
                        validationAction={validationAction}
                        actions={actions}
                        setIsEdited={setIsEdited}
                    />
                ) : null}
            </div>
        </React.Fragment>
    );
}
